const pl = {
  common: {
    close: "Zamknij",
    enabled: "Włączone",
    disabled: "Wyłączone",
  },
  header: {
    slogan:
      "Jedna z największych baz zadań i arkuszy maturalnych - ćwiczenia, wyjaśnienia i quizy.",
    loggedAs: "Zalogowany jako:",
    guestMode: "Jesteś w trybie gościa",
    roleStudent: "Uczeń",
    roleParent: "Opiekun",
    roleTutor: "Korepetytor",
    roleAdmin: "Admin",
    home: "Strona główna",
    logout: "Wyloguj się",
    login: "Logowanie",
    register: "Załóż konto",
    studentPanel: "Panel ucznia",
    parentPanel: "Panel opiekuna",
    tutorPanel: "Panel korepetytora",
    userPanel: "Panel użytkownika",
    adminPanel: "Panel administratora",
    investorPanel: "Panel inwestora",
    guestModeShort: "Tryb gościa",
    scrollTop: "Do góry",
    hideBar: "Schowaj pasek",
    showBar: "Pokaż pasek",
  },
  feedback: {
    buttonTitle: "Zgłoś problem lub wyraź opinię",
    scrollTopTitle: "Przejdź na górę strony",
    settingsTitle: "Ustawienia",
    settingsBackgroundTitle: "Ustawienia tła",
    settingsGrid: "Kratki w tle",
    settingsVariant: "Wariant tła",
    settingsVariantDefault: "Domyślne (czarny / biały)",
    settingsVariantNavy: "Granat / błękit",
    settingsVariantGreen: "Ciemna zieleń / jasna zieleń",
    settingsTheme: "Motyw interfejsu",
    settingsThemeDark: "Tryb ciemny",
    settingsThemeLight: "Tryb jasny",
    settingsHelp:
      "Warianty są normalizowane między motywami. Np. domyślny to czarne tło w ciemnym i białe w jasnym motywie.",
    settingsLanguage: "Język interfejsu",
    reportTitle: "Zgłoś problem lub podziel się opinią",
    typeBug: "Błąd w ćwiczeniu",
    typeSuggestion: "Sugestia",
    typeOther: "Inne",
    messagePlaceholder:
      "Opisz krótko problem lub sugestię.\nJeśli to błąd w ćwiczeniu: napisz co jest nie tak (np. zła odpowiedź / literówka / wykres).",
    screenshotLabel: "Screenshot / obrazek (opcjonalnie)",
    addFile: "Dodaj plik",
    screenshotHelp1: "Możesz dodać screenshot pokazujący sytuację / błąd.",
    screenshotHelp2:
      "TIP (Windows): Win + Shift + S -> potem wklej tutaj Ctrl + V (możesz też przeciągnąć obraz).",
    screenshotHelp3: "Limit: {count} obrazki, max 2MB każdy.",
    remove: "Usuń",
    errorPrefix: "Błąd:",
    sent: "Wysłano. Dzięki!",
    clear: "Wyczyść",
    sending: "Wysyłanie...",
    send: "Wyślij",
    errorsOnlyImages: "Tylko obrazki (PNG/JPG/WebP).",
    errorsMaxImages: "Maksymalnie {count} obrazki.",
    errorsImageTooBig: "Obrazek jest za duży (max 2MB).",
    errorsImageTooBigConverted: "Obrazek jest za duży po konwersji (max 2MB).",
    errorsMinMessage: "Napisz proszę krótką wiadomość (min. 3 znaki).",
    errorsSendFailed: "Nie udało się wysłać.",
  },
  userAccount: {
    title: "Panel użytkownika",
    loggedAs: "Zalogowano jako:",
    home: "Strona główna",
    tabSummary: "Podsumowanie",
    tabSubscription: "Moja subskrypcja",
    tabPassword: "Zmień hasło",
    tabProfile: "Dane profilu",
    tabFeedback: "Moje zgłoszenia",
    statusActive: "Status: aktywna do {date}{sku}",
    statusInactive: "Status: nieaktywna",
    statusLoading: "Status: ...",
    cardSubTitle: "Moja subskrypcja",
    cardSubDesc: "Sprawdź status planu, historię płatności i zarządzaj subskrypcją.",
    cardPwdTitle: "Zmień hasło",
    cardPwdDesc: "Zwiększ bezpieczeństwo konta przez zmianę hasła.",
    cardProfileTitle: "Dane profilu",
    cardProfileDesc: "Zaktualizuj e-mail, nazwę wyświetlaną i pozostałe dane.",
    cardFeedbackTitle: "Moje zgłoszenia",
    cardFeedbackDesc: "Sprawdź status zgłoszonych błędów i odpowiedzi admina.",
  },
  studentDashboard: {
    title: "Twój postęp",
    tutoring: "Korepetycje",
    tutoringPanel: "Panel korepetycji",
    viewSnapshot: "Zobacz zapis podejścia",
    noSnapshot: "Brak zapisanego podglądu",
    last: "ostatni",
    best: "najlepszy",
    lastBest: "ostatni (najlepszy)",
    completed: "Zaliczone",
    notCompleted: "Nie zaliczone",
    lockedSoon: "(wkrótce dostępny)",
    lockedTitle: "Ten podtemat jest obecnie niedostępny (wkrótce dostępny).",
    inviteAcceptError: "Nie udało się zaakceptować zaproszenia: {message}",
    inviteRejectError: "Nie udało się odrzucić zaproszenia: {message}",
    tutorInviteAcceptError: "Nie udalo sie zaakceptowac zaproszenia korepetytora: {message}",
    tutorInviteRejectError: "Nie udalo sie odrzucic zaproszenia korepetytora: {message}",
    fallbackError: "Błąd",
  },
  cards: {
    subtopics: "podtematów",
    topics: "tematy",
    avgOnlyCompleted: "Średnia skuteczność (tylko ukończone)",
    avgShort: "śr {value}%",
  },
  invites: {
    parentsTitle: "Zaproszenia od opiekunów:",
    tutorsTitle: "Zaproszenia od korepetytorów:",
    accept: "Akceptuj",
    reject: "Odrzuć",
    assignedParents: "Przypisani rodzice:",
  },
  languages: {
    pl: "Polski",
    en: "English",
  },
};

export default pl;
